const primary = 0.9;
const secondary = 0.7;

const inductorPointStyles = [
    // Colors from: https://flatuicolors.com/palette/au
    /* Some colors could still be modified slightly to show up better and
     have more contrast against other colors. */

    //Dark Grey Line 45deg (index 0 always reserved for Combined in CalcZ)
    {
        color: [`rgba(83, 92, 104,${primary})`, `rgba(149, 175, 192,1.0)`], // secondary opacity hardcoded
        width: 1.7,
        radius: 3.5,
        rotation: 0
    },
    //Yellow Circle
    {
        color: [`rgba(249, 202, 36,${primary})`, `rgba(246, 229, 141, ${secondary})`],
        width: 1.6,
        radius: 3.5,
        rotation: 0
    },
    //Kemet Blue Line 45deg
    {
        color: [`rgba(63, 72, 204,${primary})`, `rgba(63, 72, 204,${secondary})`],
        width: 1.5,
        radius: 3.5,
        rotation: 0
    },
    //Red Square
    {
        color: [`rgba(235, 77, 75,${primary})`, `rgba(255, 121, 121,${secondary})`],
        width: 1.5,
        radius: 3.5,
        rotation: 0
    },
    //Green Cross
    {
        color: [`rgba(106, 176, 76,${primary})`, `rgba(186, 220, 88,${secondary})`],
        width: 1.3,
        radius: 3.5,
        rotation: 0
    },
    //Teal Square 45deg
    {
        color: [`rgba(34, 166, 179,${primary})`, `rgba(126, 214, 223,${secondary})`],
        width: 1.2,
        radius: 3.5,
        rotation: 0
    },
    //Pink Star
    {
        color: [`rgba(190, 46, 221,${primary})`, `rgba(224, 86, 253,${secondary})`],
        width: 1.1,
        radius: 3.5,
        rotation: 0
    },
    //Orange Triangle 180deg
    {
        color: [`rgba(240, 147, 43,${primary})`, `rgba(255, 190, 118,${secondary})`],
        width: 1.0,
        radius: 3.5,
        rotation: 0
    },
    //Brown Cross 45deg
    {
        color: [`rgba(139, 69, 19,${primary})`, `rgba(139, 69, 19,${secondary})`],
        width: 0.9,
        radius: 3.5,
        rotation: 0
    },
    //Purple Triangle
    {
        color: [`rgba(75,0,130,${primary})`, `rgba(75,0,130,${secondary})`],
        width: 0.8,
        radius: 3.5,
        rotation: 0
    },
    //Dark Grey Line horiz
    {
        color: [`rgba(19, 15, 40,${primary})`, `rgba(38, 41, 97,${secondary})`],
        width: 0.7,
        radius: 3.5,
        rotation: 0
    },
    //Light Grey Line 45deg
    {
        color: [`rgba(83, 92, 104,${primary})`, `rgba(149, 175, 192,${secondary})`],
        width: 1.8,
        radius: 3.5,
        rotation: 0
    },
    //Yellow Circle
    {
        color: [`rgba(249, 202, 36,${primary})`, `rgba(246, 229, 141, ${secondary})`],
        width: 1.9,
        radius: 3.5,
        rotation: 0
    },
    //Purple
    {
        color: [`rgba(72, 52, 212,${primary})`, `rgba(104, 109, 224,${secondary})`],
        width: 2.0,
        radius: 3.5,
        rotation: 0
    },
    //Red
    {
        color: [`rgba(235, 77, 75,${primary})`, `rgba(255, 121, 121,${secondary})`],
        width: 2.0,
        radius: 4.5,
        rotation: 0
    },
    //Green
    {
        color: [`rgba(106, 176, 76,${primary})`, `rgba(186, 220, 88,${secondary})`],
        width: 0.6,
        radius: 3.5,
        rotation: 0
    },
    //Dark Grey
    {
        color: [`rgba(19, 15, 64,${primary})`, `rgba(38, 41, 97,${secondary})`],
        width: 0.5,
        radius: 3.5,
        rotation: 0
    },
    //Teal
    {
        color: [`rgba(34, 166, 179,${primary})`, `rgba(126, 214, 223,${secondary})`],
        width: 0.4,
        radius: 3.5,
        rotation: 0
    },
    //Pink
    {
        color: [`rgba(190, 46, 221,${primary})`, `rgba(224, 86, 253,${secondary})`],
        width: 1.7,
        radius: 3.5,
        rotation: 0
    },
    //Orange
    {
        color: [`rgba(240, 147, 43,${primary})`, `rgba(255, 190, 118,${secondary})`],
        width: 2.2,
        radius: 3.5,
        rotation: 0
    }
];

export default inductorPointStyles;